import {merge, get, find, map, filter} from 'lodash';
import moment from 'moment';
import {formActions, inlineSchema, displayField, updateFn, columnsFn} from './utils';
import i18n from '../i18n/index';
import * as Member from './membership';
import * as Caregiver from './caregiver';
import * as Order from './order';
import * as Group from './group';
import * as FeedbackCaregiver from './feedback-caregiver';
import * as Transaction from './transaction';
import * as Subprofile from './subprofile';
import * as ServiceLocation from './service_location';
import * as EmergencyContact from './emergency_contact';
import sweetalert from 'sweetalert2';
import debug from '../debug';
import SchemaBaseTable from 'src/components/Dashboard/Views/Tables/SchemaBaseTable.vue';
import {MessageBox} from 'element-ui';
import {formatPhone} from 'src/utils';

export default function (model) {
  return {
    //  ============================================================================= appointment
    appointment_id: {type: 'id', required: true},
    created_at: {type: 'datetime', readonly: true},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'},

    type: {type: 'string', list: false},

    'details.order.product.details.title': {
      type: 'i18n',
      label: 'schema.product',
      hidden: true,
    },

    progress_status: {
      type: 'select', default: 'matching_helper', /*readonly: true, updated @ 201712061111*/
      items: [
        'status.waiting_admin_approve',
        'status.waiting_admin_confirm',
        'status.matching_helper',
        'status.waiting_helper_confirm',
        'status.confirmed',
        'status.cancelled',
        'status.cancelled_by_sender',
        'status.in_progress',
        'status.incomplete',
        'status.complete',
      ],
      display(model, index, fieldSpec, schema, columns) {
        let value = displayField.call(this, model, index, fieldSpec, schema, columns);
        if (['matching_helper', 'incomplete'].indexOf(get(model, 'progress_status')) >= 0) {
          value = {template: `<span class="label label-danger" style="font-size: small">${value}</span>`};
        } else if (['complete'].indexOf(get(model, 'progress_status')) >= 0) {
          value = {template: `<span class="label label-success" style="font-size: small">${value}</span>`};
        }
        return value;
      },
    },
    invoice_completed: {
      type: 'boolean',
    },
    warn_modify_status: {
      type: 'label',
      label: '',
      html: true,
      list: false,
      get: () => i18n.fr('alert.html.warn_modify_status'),
    },
    progress_history: {
      readonly: true,
      type: 'array',
      itemType: {
        type: 'schema', schema: merge(inlineSchema({
          action: {type: 'label'},
          new_status: {
            type: 'select',
            items: [
              'status.waiting_admin_approve',
              'status.waiting_admin_confirm',
              'status.matching_helper',
              'status.waiting_helper_confirm',
              'status.confirmed',
              'status.cancelled',
              'status.cancelled_by_sender',
              'status.in_progress',
              'status.incomplete',
              'status.complete',
            ],
          },
          updated_at: {type: 'datetime', default: () => moment()},
          updated_by: {type: 'schema', external: true, schema: Member},
        }), {
          title(model) {
            return i18n.nn`${i18n.s('status.' + model.new_status)}: ${model.action}`;
          },
        }),
      },
    },

    sender: {
      type: 'schema', schema: merge({}, Member, {
        title(model) {
          let name = Member.title.call(this, model);
          let phone = get(model, 'verification.phone.value');
          return name + (phone ? ` (${formatPhone(phone)})` : '');
        },
      }), readonly: true, list: true,
    },
    subprofile: {
      type: 'schema', showActions: true, label: 'fields.subprofile', schema: merge({}, Subprofile, {
        title(model) {
          let name = Subprofile.title.call(this, model);
          let phone = get(model, 'details.profile.mobile');
          return name + (phone ? ` (${formatPhone(phone)})` : '');
        },
        formActions(model, schema, readonly) {
          let self = this;
          let temp = [];
          if (!readonly) {
            temp.push({
              label: i18n.fr('update_schema_$name', {name: '${i18n.schema.subprofile}'}),
              class: 'btn-success',
              validation: true,
              action: function (model, schema, columns) {
                return sweetalert({
                  html: i18n.fr('alert.html.update_subprofile'),
                  showCancelButton: true,
                  confirmButtonText: i18n.fr('action.yes'),
                  cancelButtonText: i18n.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false,
                }).then(() => {
                  return updateFn('updateAppointmentSubprofile', null, [
                    'status',
                    'type',
                    'tags',
                    'details',
                  ], payload => {
                    payload.appointment_id = self.rootModel.appointment_id;
                    payload.update_linked_subprofile = false;
                    return payload;
                  }).call(this, model, schema, columns);
                }, () => false);
              },
            });
            temp.push({
              label: i18n.fr('update_schema_$name', {name: '${i18n.schema.linked_subprofiles}'}),
              class: 'btn-success',
              validation: true,
              action: function (model, schema, columns) {
                return sweetalert({
                  html: i18n.fr('alert.html.update_linked_subprofile'),
                  showCancelButton: true,
                  confirmButtonText: i18n.fr('action.yes'),
                  cancelButtonText: i18n.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-success btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false,
                }).then(() => {
                  return updateFn('updateAppointmentSubprofile', null, [
                    'status',
                    'type',
                    'tags',
                    'details',
                  ], payload => {
                    payload.appointment_id = self.rootModel.appointment_id;
                    payload.update_linked_subprofile = true;
                    return payload;
                  }).call(this, model, schema, columns);
                }, () => false);
              },
            });
          }
          temp.push({
            label: i18n.fr('create_schema_$name', {name: '${i18n.schema.order}'}),
            class: 'btn-info',
            validation: false,
            action(model, schema) {
              this.$router.push(`/admin/orders/create?member_id=${get(model, 'creator.member_id')}&subprofile_id=${get(model, 'subprofile_id')}`);
              return Promise.resolve();
            },
          });
          return temp;
        },
      }),
    },

    potential_recipient_status: {
      type: 'select',
      readonly: true,
      hidden: true,
      items: [
        'status.pending',
        'status.accepted',
        'status.confirmed',
        'status.rejected',
        'status.arrived',
        'status.cancelled',
        'status.absent',
        'status.late',
        'status.left',
        'status.reported',
        'status.feedbacked',
        'status.invoice_sent',
        'status.complete',
      ],
      get(model) {
        return get(find(get(model, 'potential_recipients'), x => [
          'accepted',
          'confirmed',
          'arrived',
          'absent',
          'late',
          'left',
          'reported',
          'feedbacked',
          'invoice_sent',
          'complete',
        ].indexOf(x.status) >= 0), 'status');
      },
    },
    potential_recipients_count: {
      type: 'number',
      hidden: true,
      get: model => get(model, 'potential_recipients', []).length,
    },
    show_cancelled_recipients: {type: 'checkbox', list: false},
    potential_recipients: {
      type: 'array', itemType: {
        type: 'schema',
        class: model => ({
          'bg-disabled': ['cancelled', 'rejected'].indexOf(model.status) >= 0,
          'bg-success': ['cancelled', 'rejected', 'pending'].indexOf(model.status) < 0,
        }),
        showActions: true,
        schema: merge(inlineSchema({
          created_at: {type: 'datetime', readonly: true}, //  assigned at ( by admin or system)
          updated_at: {type: 'datetime', readonly: true},
          recipient: {
            type: 'schema', readonly: true,
            schema: merge({}, Member, {
              columns: columnsFn({
                member_id: {type: 'id'},
                'details.profile.first_name': {type: 'string'},
                'details.profile.last_name': {type: 'string'},
                'details.profile.gender': {type: 'select', items: ['gender.m', 'gender.f']},
                'details.profile.profile_pic': {type: 'img'},
                'verification.email.value': {
                  type: 'string',
                  label: 'fields.email',
                  list: 1,
                },
                'verification.phone.value': {
                  type: 'phone',
                  label: 'fields.phone',
                  list: 2,
                },
              }),
            }),
          },
          status: {
            type: 'select',
            // readonly: true, updated @ 201712061111
            items: [
              'status.pending',
              'status.accepted',
              'status.confirmed',
              'status.rejected',
              'status.arrived',
              'status.cancelled',
              'status.absent',
              'status.late',
              'status.left',
              'status.reported',
              'status.feedbacked',
              'status.invoice_sent',
              'status.complete',
            ],
          },
          warn_modify_status: {
            type: 'label',
            label: '',
            html: true,
            get: () => i18n.fr('alert.html.warn_modify_status'),
          },
          status_history: {
            type: 'array',
            readonly: true,
            itemType: {
              type: 'schema', schema: merge(inlineSchema({
                action: {type: 'label'},
                new_status: {type: 'label'},
                updated_at: {type: 'datetime'},
                updated_by: {type: 'schema', external: true, schema: Member},
              }), {
                title(model) {
                  return i18n.fr('status.' + model.new_status);
                },
              }),
            },
          },
        }), {
          title(model) {
            return Member.title.call(this, model.recipient) + ` (${i18n.s('status.' + model.status, '')})`;
          },
          formActions(model, schema, readonly) {
            let status = get(model, 'status');
            let appointment_progress = get(this, 'rootModel.progress_status');
            if (status == 'accepted') {
              return [{
                label: i18n.fr('action.assign_job_to_this_member'),
                action(model, spec, readonly) {
                  let payload = {
                    endpoint: 'confirmJobApplicationByAdmin',
                    appointment_id: this.rootModel.appointment_id,
                    member_id: model.recipient.member_id,
                  };

                  let p = this.$http.post('', payload);
                  p = formActions.postprocess.notify(true).call(this, p);
                  p = p.catch(response => {
                    if (['soft_time_clash', 'not_available_days_conflict'].indexOf(get(response, 'err.err_code')) >= 0) {

                      return sweetalert({
                        html: response.err.err_code == 'soft_time_clash'
                          ? i18n.fr('alert.html.time_clash_$appointments', {
                            appointments: map(response.err_details, x => `
<a href="/admin/appointments/${x.appointment_id}" target="_blank">
  ${x.appointment_id} (${moment(x.details.service_begin).format('YYYY/MM/DD HH:mm')})
</a>`),
                          })
                          : i18n.fr('alert.html.not_available_days_$days', {
                            days: map(response.err_details, x => moment(x.startTime).format('YYYY/MM/DD')),
                          }),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: i18n.fr('action.yes'),
                        cancelButtonText: i18n.fr('action.cancel'),
                        confirmButtonClass: 'btn btn-danger btn-fill',
                        cancelButtonClass: 'btn btn-fill',
                        buttonsStyling: false,
                      }).then(() => {
                        // retry

                        payload.force = true;
                        let p1 = this.$http.post('', payload);
                        p1 = formActions.postprocess.notify(true).call(this, p1);
                        return p1;

                      }, dismiss => {
                        return false; // don't reload
                      });

                    } else {
                      return Promise.reject(response.err);
                    }
                  });
                  return p;
                },
              }];
            } else if (['pending', 'accepted', 'rejected', 'cancelled'].indexOf(status) >= 0 &&
              ['in_progress', 'complete', 'incomplete'].indexOf(appointment_progress) < 0) /* requirement update on 20171114 */{
              return [{
                label: i18n.fr('action.force_assign_job_to_this_member'),
                class: 'btn-danger',
                action(model, spec, readonly) {
                  let r = find(get(this, 'rootModel.potential_recipients', []),
                    x => ['accepted', 'confirmed'].indexOf(x.status) >= 0);

                  return sweetalert({
                    html: i18n.fr(r
                      ? 'alert.html.confirm_force_assign_job_to_this_member_ignore_accepted'
                      : 'alert.html.confirm_force_assign_job_to_this_member'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: i18n.fr('action.yes'),
                    cancelButtonText: i18n.fr('action.cancel'),
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    cancelButtonClass: 'btn btn-fill',
                    buttonsStyling: false,
                  }).then(() => {

                    let payload = {
                      endpoint: 'confirmJobApplicationByAdmin',
                      appointment_id: this.rootModel.appointment_id,
                      member_id: model.recipient.member_id,
                    };

                    let p = this.$http.post('', payload);
                    p = formActions.postprocess.notify(true).call(this, p);
                    p = p.catch(response => {
                      if (['soft_time_clash', 'not_available_days_conflict'].indexOf(get(response, 'err.err_code')) >= 0) {

                        return sweetalert({
                          html: response.err.err_code == 'soft_time_clash'
                            ? i18n.fr('alert.html.time_clash_$appointments', {
                              appointments: map(response.err_details, x => `
<a href="/admin/appointments/${x.appointment_id}" target="_blank">
  ${x.appointment_id} (${moment(x.details.service_begin).format('YYYY/MM/DD HH:mm')})
</a>`),
                            })
                            : i18n.fr('alert.html.not_available_days_$days', {
                              days: map(response.err_details, x => moment(x.startTime).format('YYYY/MM/DD')),
                            }),
                          type: 'warning',
                          showCancelButton: true,
                          confirmButtonText: i18n.fr('action.yes'),
                          cancelButtonText: i18n.fr('action.cancel'),
                          confirmButtonClass: 'btn btn-danger btn-fill',
                          cancelButtonClass: 'btn btn-fill',
                          buttonsStyling: false,
                        }).then(() => {
                          // retry
                          payload.force = true;
                          let p1 = this.$http.post('', payload);
                          p1 = formActions.postprocess.notify(true).call(this, p1);
                          return p1;
                        }, dismiss => {
                          return false; // don't reload
                        });
                      } else {
                        return Promise.reject(err);
                      }
                    });
                    return p;

                  }, dismiss => {
                    return false; // don't reload'
                  });
                },
              }];
            }
            return [];
          },
        }),
      },
      get(model) {
        return get(model, 'show_cancelled_recipients')
          ? get(model, 'potential_recipients', [])
          : filter(get(model, 'potential_recipients', []), x => x.status !== 'cancelled');
      },
    },
    force_assign_caregiver: {
      type: 'button',
      label: 'action.force_assign_job',
      hidden: model && ['in_progress', 'complete', 'incomplete'].indexOf(model.progress_status) >= 0,
      actions: [{
        label: ['action.choose_$obj', {obj: '${i18n.schema.caregiver}'}],
        action(model, spec) {
          let self = this;
          let TheMember = null; // temp selection
          let addOnly = false;
          return MessageBox({
            title: i18n.fr('action.choose_$obj', {obj: '${i18n.schema.caregiver}'}),
            type: null,
            showCancelButton: true,
            closeOnPressEscape: true,
            closeOnClickModal: false,
            message: self.$createElement(SchemaBaseTable, {
              key: +new Date(), // required to force regenerate the vnode
              props: {
                schema: {
                  ...Caregiver,
                  view(row) {
                    TheMember = row;
                  },
                },
                listActions: false,
                embedded: true,
                selectable: true,
                perPage: 10,
              },
            }),
            beforeClose(action, instance, done) {
              if (action === 'confirm') {
                if (!TheMember) {
                  alert(i18n.fr('alert.please_choose_an_item_by_clicking_a_row'));
                } else {
                  addOnly = !confirm(i18n.fr('alert.force_assign_job_add_only'));
                }
              }
              done();
            },
          }).then(async () => {

            let r = find(get(self, 'rootModel.potential_recipients', []),
              x => ['accepted', 'confirmed'].indexOf(x.status) >= 0);

            let ok = addOnly ? true : await sweetalert({
              html: i18n.fr(r
                ? 'alert.html.confirm_force_assign_job_to_this_member_ignore_accepted'
                : 'alert.html.confirm_force_assign_job_to_this_member'),
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: i18n.fr('action.yes'),
              cancelButtonText: i18n.fr('action.cancel'),
              confirmButtonClass: 'btn btn-danger btn-fill',
              cancelButtonClass: 'btn btn-fill',
              buttonsStyling: false,
            }).then(() => true, () => false);

            if (!ok) {
              return;
            }
            let payload = {
              endpoint: 'confirmJobApplicationByAdmin',
              appointment_id: self.rootModel.appointment_id,
              member_id: TheMember.member_id,
              status: addOnly ? 'pending' : 'confirmed',
            };

            let p = self.$http.post('', payload);
            p = formActions.postprocess.notify(true).call(self, p);
            p = p.catch(response => {
              if (['soft_time_clash', 'not_available_days_conflict'].indexOf(get(response, 'err.err_code')) >= 0) {

                return sweetalert({
                  html: response.err.err_code == 'soft_time_clash'
                    ? i18n.fr('alert.html.time_clash_$appointments', {
                      appointments: map(response.err_details, x => `
<a href="/admin/appointments/${x.appointment_id}" target="_blank">
  ${x.appointment_id} (${moment(x.details.service_begin).format('YYYY/MM/DD HH:mm')})
</a>`),
                    })
                    : i18n.fr('alert.html.not_available_days_$days', {
                      days: map(response.err_details, x => moment(x.startTime).format('YYYY/MM/DD')),
                    }),
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: i18n.fr('action.yes'),
                  cancelButtonText: i18n.fr('action.cancel'),
                  confirmButtonClass: 'btn btn-danger btn-fill',
                  cancelButtonClass: 'btn btn-fill',
                  buttonsStyling: false,
                }).then(() => {
                  // retry

                  payload.force = true;
                  let p1 = self.$http.post('', payload);
                  p1 = formActions.postprocess.notify(true).call(self, p1);
                  return p1;

                }, dismiss => {
                  return false; // don't reload
                });

              } else {
                return Promise.reject(response.err);
              }
            });
            return p;

          }, () => {
            // dismiss
          });
        },
      }],
    },
    required_groups: {
      type: 'array', readonly: true,
      itemType: {
        type: 'schema', schema: merge(inlineSchema({
          group: {type: 'schema', required: true, schema: Group, external: true},
          required_self_status: {type: 'select', items: ['status.pending', 'status.approved', 'status.admin']},
        }), {
          title(model) {
            return Group.title.call(this, get(model, 'group'), Group);
          },
        }),
      },
    },

    'details.service_date': {type: 'datetime', hidden: true},
    details: {
      type: 'schema', schema: merge(inlineSchema({
        order: {type: 'schema', schema: Order, external: true, required: true},
        service_date: {
          type: 'datetime',
          readonly: model && ['complete', 'incomplete'].indexOf(model.progress_status) >= 0,
        },
        timeslot: {type: String, readonly: true},
        service_begin: {type: 'datetime', readonly: true},
        service_end: {type: 'datetime', readonly: true},
        service_cooldown: {type: 'datetime', readonly: true},
        ratio: {label: 'fields.ticket_required', type: 'label', default: 1, readonly: true},
        'caregiver_report.content': {
          label: 'fields.caregiver_report',
          type: 'array', readonly: true,
          itemType: {
            type: 'schema',
            schema: inlineSchema({
              time: {type: 'datetime'},
              note: {type: 'string'},
            }),
          },
        },
        'order.service_location': {type: 'schema', readonly: true, schema: ServiceLocation},
        'order.emergency_contact': {type: 'schema', readonly: true, schema: EmergencyContact},
        feedbacks: {type: 'array', itemType: {type: 'schema', schema: FeedbackCaregiver, external: true}},
        invoices: {type: 'array', itemType: {type: 'schema', schema: Transaction, external: true}},
        'order.remarks': {type: 'text', readonly: true, label: 'fields.order_remarks'},
        remarks: {type: 'text'},
      }), {
        title(model) {
          let addr = get(model, 'order.service_location');
          if (addr) {
            return ServiceLocation.title.call(this, addr);
          }
          return '';
        },
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/schemas/appointment_db.js